import { filterNumeric } from '@/utils/number';
import { TextField } from '@lego/connect-components-react';
import type { ComponentProps } from 'react';

type NumericTextFieldProps = ComponentProps<typeof TextField> & {
  integerOnly?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => void;
};

export default function NumericTextField({
  integerOnly = false,
  onChange,
  ...rest
}: NumericTextFieldProps) {
  return (
    <TextField
      placeholder="0"
      {...rest}
      onChange={(event) => {
        const raw = event.currentTarget.value;
        const filtered = integerOnly
          ? raw.replace(/\D/g, '')
          : filterNumeric(raw);
        event.currentTarget.value = filtered;
        onChange?.(event, filtered);
      }}
      onBlur={(event) => {
        const value = event.currentTarget.value;
        const cleaned = value.replace(/[.,]$/, '');
        if (cleaned !== value) {
          event.currentTarget.value = cleaned;
          onChange?.(
            event as unknown as React.ChangeEvent<HTMLInputElement>,
            cleaned,
          );
        }
        rest.onBlur?.(event);
      }}
    />
  );
}
